import {
  invalidMessage,
  positiveMessage
} from 'messages'
import { getObjectUtil } from 'packages/src'

const VALIDATOR = {
  value: valuePromoCodeUtil,
  expireAt: expireAtPromoCodeUtil
}

function getValidatorPromoCodeUtil (name) {
  const validate = () => true
  return VALIDATOR[name] || validate
}

function valuePromoCodeUtil (value) {
  if (isNaN(parseFloat(value))) {
    return invalidMessage('value')
  }
  value = parseFloat(value)
  if (value < 0) {
    return positiveMessage('value')
  }
  if (value > 100) {
    return invalidMessage('value')
  }
  return true
}

function expireAtPromoCodeUtil (value) {
  if (isNaN(value)) {
    return invalidMessage('expireAt')
  }
  value = parseInt(value, 10)
  if (value < 0) {
    return positiveMessage('expireAt')
  }
  return true
}

/**
 * Checks whether the given `PromoCode` is expired.
 * @param  {PromoCode|Object} promoCode
 * @returns {boolean}
 */
function isExpiredPromoCodeUtil (promoCode) {
  const expireAt = (
    getObjectUtil(promoCode, 'data.expireAt') || getObjectUtil(promoCode, 'expireAt')
  )
  if (!expireAt) {
    return false
  }
  const now = new Date()
  return expireAt && new Date(expireAt).getTime() < now.getTime()
}

export {
  getValidatorPromoCodeUtil,
  isExpiredPromoCodeUtil
}
